export const messaging = {
  profileDialog: {
    dialpadUserCanSwitch:
      'This user sends and receives on Dialpad. Switching assigns them a Twilio number for sending. Their Dialpad number is kept and still receives patient replies.',
    dialpadUserCannotSwitch: 'This user sends and receives on Dialpad. Only a Super Admin or PSM can move them to a Twilio number.',
    moveToTwilioLabel: 'Move this user to a Twilio number',
    systemSenderOption: (phoneNumber: string) => `${phoneNumber} (system sender)`,
    retainedDialpadLabel: 'Previous Dialpad number',
    retainedDialpadHelper: 'Receives patient replies only. New messages are sent from the Twilio number.'
  },
  smsOptOut: {
    banner: (date: string, keyword: string) => `Opted out of text messages on ${date} (patient replied ${keyword}). Texts cannot be sent.`,
    carrierBlockBanner: (date: string) => `Opted out of text messages on ${date} (blocked by the carrier). Texts cannot be sent.`,
    pillTitle: 'Messaging (patient opted out of text messages)',
    phoneTooltip: (date: string) =>
      `Patient opted out of text messages (SMS) on ${date}. Call or use other approved methods to contact. Update phone number if incorrect.`,
    tagFilterLabel: 'Opted out of texts'
  },
  smsRestart: {
    pendingNotice: (restartedBy: string, date: string, number: string) =>
      `Texts restarted by ${restartedBy} on ${date}. Ask the patient to text START to ${number} to finish turning texts back on.`,
    otherPharmacyStaff: 'staff at another pharmacy',
    unknownNumber: 'the number they opted out from',
    pendingIconLabel: 'Texts restarted, waiting for the patient to text START',
    openPatientSettings: 'Open Patient Settings',
    restartButton: 'Restart texts',
    dialogTitle: 'Restart text messages',
    dialogIntro: (date: string) =>
      `This patient's phone number opted out of text messages on ${date}. Record that the patient agreed to receive texts again.`,
    consentedOnLabel: 'Date the patient agreed',
    consentMethodLabel: 'How they agreed',
    consentMethods: {
      VERBAL_IN_PERSON: 'Verbal, in person',
      VERBAL_BY_PHONE: 'Verbal, by phone',
      WRITTEN: 'Written'
    },
    confirmLabel: 'I confirm the patient agreed to receive text messages again.',
    sharedNumberNotice: 'This phone number is shared. Restarting texts applies to everyone on it:',
    otherPharmacyCount: (count: number) => `and ${count} ${count === 1 ? 'patient' : 'patients'} at other pharmacies`,
    remindersStayOff: 'Text reminders stay off until you turn them on.',
    saveButton: 'Restart texts',
    cancelButton: 'Cancel',
    failed: 'Could not restart text messages. Please try again.'
  },
  deliveryStatus: {
    sending: 'Sending',
    sent: 'Sent',
    delivered: 'Delivered',
    notDelivered: 'Not delivered',
    errorDetailsLabel: 'Delivery error details',
    errorWithMessage: (code: string, message: string) => `Error ${code}: ${message}`,
    errorCodeOnly: (code: string) => `Error ${code}`
  }
} as const;
